import React, { useState } from 'react'

export default function MediaPreview({ type, text, images, video }) {
    const [IsShowing, setIsShowing] = useState(false)

    function handleClose() {
        setIsShowing(false)
    }

    return (
        <>
            {type === "text" && <button className="btn btn-default" onClick={() => setIsShowing(true)}>
                Text 
            </button>}
            {type === "photo" && <button className="btn btn-default" onClick={() => setIsShowing(true)}>
                <i className="fas fa-image"></i> Image 
            </button>}
            {type === "video" && <button className="btn btn-default" onClick={() => setIsShowing(true)}>
                <i className="fas fa-video"></i> Video 
            </button>}
            {IsShowing && <div className={`modal fade show`} id="modal-default" style={{ display: 'block', paddingRight: 17 }} aria-modal="true" role="dialog">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"></h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => handleClose()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '83vh', overflowY: 'auto' }}>
                            {type === "photo" && images?.map(image => <img src={image} alt="Media View" style={{ width: '50%' }} />)}
                            {type === "video" && <video src={video} style={{ width: '100%' }} controls />}
                            {type === "text" && <div>
                                {text}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}
